module.exports = __webpack_public_path__ + "media/images/sports_icons/music-9cb1da3a3a6d09b751ef5e213009bf4d.png";